import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "../../../hooks";
import styles from "./Battery.module.scss";
import energyIcon from "./icons/energy.png";
import { now } from "../../../utils/time";
import { BatterySvg } from "./BatterySvg";
import { shortNumberForm } from "../../../utils/numbers";
import { updateCurrentEnergy } from "../../../redux/work";

export const Battery = () => {
    const [energyValue, setEnergyValue] = useState(0);
    const { capacity, lastConvertDate, storeSpeed } = useSelector(store => store.work);

    const dispatch = useDispatch();

    useEffect(() => {
        const update = () => {
            if (!storeSpeed || !capacity)
                return;

            const storeTime = now() - lastConvertDate;
            const newEnergyValue = Math.floor(Math.max(Math.min(storeTime * storeSpeed.value, capacity.value), 0));
            
            if (energyValue === newEnergyValue)
                return;
            
            setEnergyValue(newEnergyValue);
            dispatch(updateCurrentEnergy(newEnergyValue));
        }
        update();
        const intervalId = setInterval(update, 1000);

        return () => {
            clearInterval(intervalId);
        };
    }, [lastConvertDate, capacity, storeSpeed, dispatch]);

    const getBattegyValue = () => {
        if (!capacity || !capacity.value)
            return 0;

        return energyValue / capacity.value * 100;
    }

    return (
        <div className={styles.batteryWrapper}>
            <BatterySvg value={ getBattegyValue() } />

            <span className={styles.batteryText}>
                { `${shortNumberForm(energyValue, 1) ?? 0} / ${shortNumberForm(capacity?.value ?? 0, 1)}` }
            </span>

            <img src={energyIcon} alt="Energy" className={styles.batteryIcon} />
        </div>
    );
}